import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id B03A16BE-0679-4635-B2F7-6553C3761211
 * name moon-waning-gibbous
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/moon-waning-gibbous.svg
 * tags
 * - Weather 
 */
export const MoonWaningGibbousIcon = createSvgIcon(<><path d="M18 12C18 7.5 16.08 3.26 12 2A10 10 0 0 0 12 22C16.08 20.74 18 16.5 18 12Z" /></>, 'MoonWaningGibbousIcon');
export default MoonWaningGibbousIcon